// Auth Getters

export const getAuthUserData = state => {
  return state.authUserData
}

export const getAuthToken = state => {
  return state.authToken
}

export const loginCashiersList = state => {
  return state.loginCashiersList
}
